import styled from '@emotion/styled';
import { Title } from '@teko/ds-mobile';
import { useProductDetailState } from 'contexts';
import { t } from 'i18n';
import { useEffect, useState } from 'react';
import { RelatedPosts } from './RelatedPosts';
import { RelatedVideos } from './RelatedVideos';
import { TabItem } from './TabItem';

type Tab = 'POST' | 'VIDEO' | '';
export const MAX_ITEMS_WITH_TWO_BLOCKS = 3;

export const ProductNews = () => {
  const [activeTab, setActiveTab] = useState<Tab>('POST');
  const { product } = useProductDetailState();
  const { relatedPosts, relatedVideos } = product?.seoInfo || {
    relatedPosts: { title: '' },
    relatedVideos: { title: '' },
  };

  useEffect(() => {
    if (!!product?.seoInfo?.relatedPosts) {
      setActiveTab('POST');
      return;
    }
    if (!!product?.seoInfo?.relatedVideos) {
      setActiveTab('VIDEO');
      return;
    }
    setActiveTab('');
  }, [product?.seoInfo]);

  if (
    !product?.seoInfo?.relatedVideos?.urls?.length &&
    !product?.seoInfo?.relatedPosts?.urls?.length
  ) {
    return <></>;
  }

  return (
    <Wrapper>
      <Title>{t('Tin tức sản phẩm')}</Title>
      <StyledHeader>
        {!!product?.seoInfo?.relatedPosts && (
          <TabItem
            onClick={() => setActiveTab('POST')}
            isActive={activeTab === 'POST'}
            title={relatedPosts?.title || ''}
          />
        )}
        {!!product?.seoInfo?.relatedVideos && (
          <TabItem
            onClick={() => setActiveTab('VIDEO')}
            isActive={activeTab === 'VIDEO'}
            title={relatedVideos?.title || ''}
          />
        )}
      </StyledHeader>
      <div>
        {activeTab === 'POST' && product?.seoInfo?.relatedPosts && (
          <RelatedPosts relatedPosts={product?.seoInfo?.relatedPosts} />
        )}
        {activeTab === 'VIDEO' && product?.seoInfo?.relatedVideos && (
          <RelatedVideos relatedVideos={product?.seoInfo?.relatedVideos} />
        )}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
`;

const StyledHeader = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
`;
